import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_SUB_PRACTICE_DETAIL = 'GET_SUB_PRACTICE_DETAIL';
export const GET_SUB_PRACTICE_DETAIL_SUCCESS =
  'GET_SUB_PRACTICE_DETAIL_SUCCESS';
export const GET_SUB_PRACTICE_DETAIL_FAILURE =
  'GET_SUB_PRACTICE_DETAIL_FAILURE';

// Action Creators
export const getSubPracticeDetailRequest = () => ({
  type: GET_SUB_PRACTICE_DETAIL,
});

export const getSubPracticeDetailSuccess = (users) => ({
  type: GET_SUB_PRACTICE_DETAIL_SUCCESS,
  payload: users,
});

export const getSubPracticeDetailFailure = (error) => ({
  type: GET_SUB_PRACTICE_DETAIL_FAILURE,
  payload: error,
});

// Thunk Function
export const getSubPracticeDetail = (external, id) => {
  return async (dispatch) => {
    dispatch(getSubPracticeDetailRequest());
    try {
      const response = await getMethodWithToken(
        url.getSubPracticeDetail + id + '/'
      );
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getSubPracticeDetailSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getSubPracticeDetailFailure(error?.message));
    }
  };
};
